import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import InputTextField from "../../../components/input/inputTextField";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import {
  NavigateNext,
  RemoveRedEyeOutlined,
  SearchOutlined,
} from "@mui/icons-material";
import { ButtonPrimary } from "../../../components/button/ButtonCustoms";
import { mockLeaveType } from "../../../utils/mockData";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { leaveTypeApi } from "../../../api/leave-type/leave-type.api";
import { dateTimeToView } from "../../../utils/date.utils";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { checkPermission, debouncedApiCall } from "../../../utils/app.utils";
import { RootState } from "../../../store/store";

type Props = {};

const ManageLeaveType: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();


  const profileReducer = useSelector((state: RootState) => state.profile.profile);
  const permission: any[] = profileReducer?.permission || [];
  const checkPermit = checkPermission('ManageLeaveType', permission);

  const [dataLeaveType, setDataLeaveType] = useState<any[]>([]);
  const [search, setSearch] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getLeaveType = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
    };

    if (search) query = { ...query, leave_type_name: search };

    const res = await leaveTypeApi.getAllLeaveType(query);
    const data = res.data;
    if (data.status < 300) {
      setDataLeaveType(data.data.items);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
    } else {
      setDataLeaveType([]);
    }
  };

  const handleSubmit = async (id: number, status: string) => {
    await leaveTypeApi
      .updateLeaveType(id, {
        status: status,
      })
      .then((res) => {
        if (res.status < 300) {
          dispatch(unsetLoading());
          alertSuccess(
            "แก้ไขสถานะรูปแบบการลา",
            "แก้ไขสถานะรูปแบบการลา เรียบร้อยแล้ว",
            undefined,
            () => {
              dispatch(unsetLoading());
              getLeaveType();
            }
          );
        }
      })
      .catch(() => {
        alertError("แก้ไขสถานะรูปแบบการลา ไม่สำเร็จ");
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  };

  const headCells = [
    // {
    //   id: "#",
    //   width: 2,
    //   sortable: false,
    //   disablePadding: false,
    //   align: "center",
    //   label: "#",
    // },
    {
      id: "leave_type_name",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชื่อรูปแบบ",
    },
    {
      id: "status",
      disablePadding: false,
      width: 5,
      sortable: false,
      align: "center",
      label: "สถานะ",
    },
    {
      id: "user_updated",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "ผู้สร้าง/ปรับปรุงล่าสุด",
    },
    {
      id: "last_updated",
      disablePadding: false,
      align: "center",
      width: 50,
      label: "วันที่สร้าง/ปรับปรุงล่าสุด",
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const { id_leave_type, leave_type_name, status, modified, modified_date, created } =
      objData;

    const objRenderData = {
      key: id_leave_type,
      id: no,
      obj: objData,
      columns: [
        // {
        //   option: "TEXT",
        //   align: "center",
        //   label: no || "-",
        // },
        {
          option: "TEXT",
          align: "start",
          label: leave_type_name,
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <div className="w-full flex justify-center ">
              <SwitchCustom
                disabled={!checkPermit.isUpdate}
                checked={status === "active" ? true : false}
                onChange={(value: boolean) => {
                  handleSubmit(id_leave_type, value ? "active" : "inactive");
                }}
              />
            </div>
          ),
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: modified ? (
            <>
              {modified?.title +
                " " +
                modified?.first_name +
                " " +
                modified?.last_name}
            </>
          ) : created ?
            `${created?.title || ""} ${created?.first_name || ""} ${created?.last_name}`
            : (
              "-"
            ),
        },
        {
          option: "TEXT",
          align: "center",
          label: modified_date ? dateTimeToView(modified_date) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              {checkPermit.isView && (
                <RemoveRedEyeOutlined
                  onClick={() => {
                    navigate(
                      routeName.cms.ManageLeaveType + `/${id_leave_type}/update`
                    );
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                />
              )}
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  useEffect(() => {
    getLeaveType();
  }, [page, pageLimit, sortBy, sortType, search]);

  return (
    <div>
      <ContentHeading
        title={"จัดการรูปแบบการลา"}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหาชื่อรูปแบบ"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article
          className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          {checkPermit.isCreated && (
            <ButtonPrimary
              onClick={() => {
                navigate(routeName.cms.ManageLeaveType + `/create`);
              }}
              mode="add"
              buttonName={"เพิ่มรูปแบบการลา"}
            />
          )}
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataLeaveType &&
            dataLeaveType.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default ManageLeaveType;
